import {useSelector, useStore} from "@/components/resume/redux/hooks";
import React, {useCallback, useEffect, useImperativeHandle, useMemo,useState} from "react";
import useConfigRender from "@/components/resume/hooks/useConfigRender";
import withComponent from "@/hoc/withComponent";
import useDispatch from "@/components/resume/redux/hooks/useDispatch";
import templateSlice from "@/components/resume/redux/services/templateSlice";
import resumeDataSlice from "@/components/resume/redux/services/resumeDataSlice";
import useDataChange from "@/components/resume/hooks/useDataChange";
import resumeSlice from "@/components/resume/redux/services/resumeSlice";
import config from "@/const";
import useForceUpdate from "@/hooks/useForceUpdate";
import Pagination from "@/components/resume/Pagination/index";
import useVersion from "./hooks/useVersion"
import withStore from "./hoc/withStore";
import useResumeInstance from "@/components/resume/hooks/useResumeInstance";
import withResumeInstance from "@/components/resume/hoc/withResumeInstance";
import usAiDecision from "@/components/resume/hooks/usAiDecision";
import styled from "styled-components"
import axios from "axios";
import { Module } from "@/common/module/module";
import {message} from "antd";
import './index.scss'
import './icon.scss'
import './template.scss'
import classNames from "classnames";

const ContainerStyled = styled.div`
  * {
    box-sizing: border-box;
  }

  span {
    line-height: normal;
  }

  p {
    line-height: normal;
  }

  ul {
    padding: 0;
    list-style-type: none;
  }
  .page-button{
    width: 158px;
    height: 32px;
    background: rgba(153,153,153);
    border-radius: 17px;
    color:#fff;
    left: calc( 50% - 79px );
    position:fixed;
    bottom: 45px;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    
    &:hover{
        background: rgba(76,76,76);
        cursor: pointer;
    }
  }

`
const LoadingIcon = ({style})=><div style={{width: 12, height: 12, position: "relative",...style}} dangerouslySetInnerHTML={{
    __html: `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="智能一页交互调整" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="hover显示“智能一页”" transform="translate(-1133.000000, -1048.000000)" fill="#FFFFFF" fill-rule="nonzero">
            <g id="编组-5备份-9" transform="translate(1111.000000, 1040.000000)">
                <g id="模块管理备份-3" transform="translate(22.000000, 8.000000)">
                    <path d="M11.1723911,12.5649291 C11.3001931,12.7806543 11.2286719,13.069074 11.0047339,13.1910098 C10.7854889,13.3188118 10.5064551,13.2437708 10.3821612,13.0233525 C10.2485047,12.8076156 10.3258921,12.5250621 10.5427906,12.3972601 C10.7702484,12.2706431 11.0445891,12.3480188 11.1723911,12.5649173 L11.1723911,12.5649291 Z M8.46990648,13.5415765 C8.46990648,13.7913025 8.26355548,14 8.0044435,14 C7.7547175,14 7.54602001,13.7959955 7.54602001,13.5415765 L7.54602001,13.2203175 C7.54602001,12.9647253 7.75587902,12.7607208 8.0044435,12.7607208 C8.26003574,12.7607208 8.46990648,12.9647253 8.46990648,13.2203175 L8.46990648,13.5415765 Z M5.64079309,13.0233525 C5.51064461,13.249637 5.22809111,13.3211583 5.01118088,13.1933563 C4.78841614,13.0679008 4.70986713,12.7876938 4.84117713,12.5637558 L5.18235787,11.9669711 C5.3136796,11.7477261 5.59505985,11.6715236 5.81782459,11.7969673 C6.03356158,11.9247693 6.11328383,12.2096693 5.9819621,12.4265796 L5.64078136,13.0233525 L5.64079309,13.0233525 Z M3.44479993,11.1697134 C3.22203519,11.2939956 2.93713519,11.2189546 2.81518772,10.9997096 C2.68505097,10.7839726 2.75891871,10.4979111 2.97932522,10.3700974 L3.89618392,9.83897943 C4.11544065,9.71705542 4.40034065,9.78623017 4.52579614,10.0089832 C4.65006664,10.2247202 4.57386414,10.5107934 4.35579239,10.6385954 L3.44479993,11.1697134 Z M2.46931399,8.46018923 C2.21372174,8.46018923 2.0108905,8.25383823 2.0108905,8.00175401 C2.0108905,7.74616177 2.21372174,7.53981077 2.46931399,7.53981077 L3.8973689,7.53981077 C4.15296115,7.53981077 4.35580412,7.74616177 4.35580412,7.99824599 C4.35580412,8.25383823 4.15296115,8.46018923 3.8973689,8.46018923 L2.46931399,8.46018923 L2.46931399,8.46018923 Z M2.98049847,5.62638284 C2.75774546,5.5021006 2.68505097,5.22072036 2.81636097,5.00029038 C2.93829671,4.77752564 3.22203519,4.70249638 3.44597318,4.83028663 L4.99829861,5.73190484 C5.21753187,5.85734859 5.29022636,6.13756733 5.16830235,6.35446582 C5.03815387,6.57723057 4.75558864,6.64875181 4.53986339,6.52446957 L2.98049847,5.62638284 Z M4.84117713,3.43156293 L5.92217334,5.30864362 C6.05349507,5.52790034 6.33487532,5.60644935 6.55412032,5.47630086 C6.77337704,5.35203036 6.8460598,5.06711863 6.71825782,4.84670038 L5.63258035,2.97313945 C5.50829811,2.75622922 5.22691786,2.67768021 5.01000763,2.8054822 C4.78724289,2.93327245 4.71573338,3.21582595 4.84117713,3.43156293 Z M7.54719326,2.46194323 C7.54719326,2.21221723 7.75705226,2 8.00561675,2 C8.26120899,2 8.47107972,2.20752424 8.47107972,2.46194323 L8.47107972,4.62393564 C8.47107972,4.87952788 8.26472873,5.08587888 8.00561675,5.08939862 C7.75587902,5.08939862 7.54719326,4.88656738 7.54719326,4.62393564 L7.54719326,2.46194323 Z M10.3763066,2.97312771 C10.5076166,2.75036297 10.7854889,2.67768021 11.0059071,2.80312397 C11.2286719,2.92740621 11.3072326,3.20879819 11.1759109,3.43273618 L10.0925682,5.30981687 C9.97063242,5.52907359 9.68221268,5.60644935 9.46296769,5.47982061 C9.24372269,5.35203036 9.1710282,5.06711863 9.29531044,4.84670038 L10.3763066,2.97313945 L10.3763066,2.97312771 Z M12.5781543,4.83028663 L10.6987271,5.91362934 C10.4794821,6.03791158 10.4032679,6.31930356 10.5287234,6.54322982 C10.6588601,6.7589668 10.9414254,6.83166129 11.1583239,6.71088706 L13.0389243,5.62755609 C13.2546613,5.50327385 13.3343835,5.22188187 13.2030735,5.00146363 C13.0764448,4.77869889 12.7938913,4.69897663 12.5781543,4.83028663 L12.5781543,4.83028663 Z M13.5442543,7.53981077 C13.802193,7.53981077 14.0061975,7.74616177 14.0026778,8.00175401 C14.0026778,8.25383823 13.8033663,8.46018923 13.5442543,8.46018923 L11.3799154,8.46018923 C11.1301894,8.46018923 10.9203186,8.25383823 10.9203186,7.99824599 C10.9203186,7.74616177 11.1301894,7.53981077 11.3799154,7.53981077 L13.5442543,7.53981077 L13.5442543,7.53981077 Z" id="形状"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`
}}/>

const NormalIcon = ({style})=> <div style={{width: 12, height: 12, position: "relative",...style}} dangerouslySetInnerHTML={{
    __html: `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="智能一页交互调整-📑📑" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="默认进行分页展示" transform="translate(-334.000000, -79.000000)" fill="#FFF" fill-rule="nonzero">
            <g id="模块管理备份-3" transform="translate(334.000000, 79.000000)">
                <g id="编组" transform="translate(2.222222, 0.902222)">
                    <path d="M2.13346256,8.41038568 C2.13346256,8.64767039 2.32874997,8.84295781 2.56603469,8.84295781 L9.03571789,8.84295781 C9.2730026,8.84295781 9.46829002,8.64767039 9.46829002,8.41038568 C9.46829002,8.17310096 9.2730026,7.97781354 9.03571789,7.97781354 L2.56603469,7.97781354 C2.32665011,7.97781354 2.13346256,8.17310096 2.13346256,8.41038568 Z M2.13346256,5.9357176 C2.13346256,6.17300232 2.32874997,6.36828974 2.56603469,6.36828974 L4.90873376,6.36828974 C5.14601848,6.36828974 5.3413059,6.17300232 5.3413059,5.9357176 C5.3413059,5.69843289 5.14601848,5.50314547 4.90873376,5.50314547 L2.56603469,5.50314547 C2.32665011,5.50314547 2.13346256,5.69843289 2.13346256,5.9357176 Z M9.03571789,10.4524816 L2.56603469,10.4524816 C2.32874997,10.4524816 2.13346256,10.647769 2.13346256,10.8850538 C2.13346256,11.1223385 2.32874997,11.3176259 2.56603469,11.3176259 L9.03571789,11.3176259 C9.2730026,11.3176259 9.46829002,11.1223385 9.46829002,10.8850538 C9.46829002,10.647769 9.2730026,10.4524816 9.03571789,10.4524816 Z" id="形状"></path>
                    <path d="M7.31382882,0 L0.825396825,0 C0.369542746,0 0,0.369542746 0,0.825396825 L0,13.3696887 C0,13.8255428 0.369542746,14.1950855 0.825396825,14.1950855 L10.7301587,14.1950855 C11.1860128,14.1950855 11.5555556,13.8255428 11.5555556,13.3696887 L11.5555556,4.24172673 L7.31382882,0 Z M7.87659257,1.78698488 L9.86936419,3.7797565 L8.02568296,3.7797565 C7.9458881,3.7797565 7.87659257,3.71046096 7.87659257,3.6306661 L7.87659257,1.78698488 Z M0.865144265,13.3299412 L0.8630444,13.3278414 L0.8630444,0.867244129 L0.865144265,0.865144265 L6.9757506,0.865144265 L7.00934844,0.8987421 L7.00934844,3.62856624 C7.00934844,4.18713025 7.46711895,4.6428009 8.0235831,4.6428009 L10.6883114,4.6428009 L10.6883114,13.3278414 L0.865144265,13.3299412 Z" id="形状"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`
}}/>

const CancelIcon = ({style})=> <div style={{width: 12, height: 12, position: "relative",...style}} dangerouslySetInnerHTML={{
    __html: `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="智能一页交互调整" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="hover显示“智能一页”" transform="translate(-1150.000000, -1115.000000)" fill="#FFFFFF">
            <g id="编组-5备份-10" transform="translate(1111.000000, 1107.000000)">
                <g id="模块管理备份-3" transform="translate(39.000000, 8.000000)">
                    <path d="M10,2 L14,2 L14,4 L11,4 L11,12 L14,12 L14,14 L10,14 L10,2 Z M5,12 L5,4 L2,4 L2,2 L6,2 L6,14 L2,14 L2,12 L5,12 Z" id="形状备份" fill-rule="nonzero" transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "></path>
                    <path d="M1.3925,6.53458953 L3.20825,7.79508953 C3.27555456,7.84180606 3.31569787,7.91853567 3.31569787,8.00046453 C3.31569787,8.08239338 3.27555456,8.159123 3.20825,8.20583953 L1.3925,9.46633953 C1.31608674,9.51934977 1.21656358,9.52556225 1.13415113,9.48246632 C1.05173868,9.43937038 1.00005994,9.35408989 1,9.26108953 L1,6.73983953 C1.00005994,6.64683916 1.05173868,6.56155868 1.13415113,6.51846274 C1.21656358,6.4753668 1.31608674,6.48157929 1.3925,6.53458953 Z M14.8813489,6.51846274 C14.9637613,6.56155868 15.0154401,6.64683916 15.0155,6.73983953 L15.0155,9.26108953 C15.0154401,9.35408989 14.9637613,9.43937038 14.8813489,9.48246632 C14.7989364,9.52556225 14.6994133,9.51934977 14.623,9.46633953 L12.80725,8.20583953 C12.7399454,8.159123 12.6998021,8.08239338 12.6998021,8.00046453 C12.6998021,7.91853567 12.7399454,7.84180606 12.80725,7.79508953 L14.623,6.53458953 C14.6994133,6.48157929 14.7989364,6.4753668 14.8813489,6.51846274 Z" id="形状结合"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`
}}/>


const Component = withComponent(withStore(withResumeInstance((props) => {
    const {
        baseWidth = config.resume.width,
        baseHeight = config.resume.height,
        width,
        template: template$1,
        data: $data,
        resume: $resume,
        openEdit,
        resumeRef,
        isTest,
        isDown,
        stopSkeleton
    } = props;
    const {onInit} = props;
    const {onChange} = props;
    const instance = useResumeInstance();
    const template = useSelector(state => state.template);
    const resume = useSelector(state => state.resume);
    const resumeData = useSelector(state => state.resumeData);
    const openAutoPagination = useSelector((state) => state.pagination.openAutoPagination);
    const openAutoOnePage = useSelector((state) => state.pagination.openAutoOnePage);
    const onePageLevel = useSelector((state) => state.pagination.onePageLevel);
    console.log('resume', resume)
    const configRender = useConfigRender();
    const [, update] = useForceUpdate();
    const store = useStore();
    const dispatch = useDispatch();
    const getScale = (width) => {
        return (width || 0) / baseWidth;
    };
    const rootRefHandler = useCallback((container) => {
        if (container) {
            instance.rootContainer = container;
        }
    }, []);
    const zoomRefHandler = useCallback((container) => {
        if (container) {
            instance.zoomContainer = container;
        }
    }, [])
    const contentRefHandler = useCallback((container) => {
        if (container) {
            instance.contentContainer = container;
        }
    }, [])
    let scale = instance.scale;

    const initData = async () => {
        if (template$1) {
            store.dispatch(templateSlice.actions.set(template$1));
        }
        if ($data) {
            store.dispatch(resumeDataSlice.actions.set($data));
        }
        if ($resume) {
            store.dispatch(resumeSlice.actions.set($resume));
        }
        const {resume, resumeData, template, pagination} = store.getState();
        instance.changeTheme(resume.themeIndex)
        if (pagination && pagination.onePageLevel) {
            instance.setPaginationOnePageLevel(pagination.onePageLevel)
        }
        const {linkConfig} = template || {};
        if (linkConfig) {
            const linkPromiseList = linkConfig.map((item) => {
                const link = document.createElement("link");
                const src = "https://web.static.jianzeppt.com/resume-css/" + item.href;
                if (item.href.indexOf("c1e4d770.css") === -1 && item.href.indexOf("2ace02b3.css") === -1 && item.href.indexOf("cbc1b7bf.css") === -1) {
                    link.setAttribute("href", src);
                    link.setAttribute("rel", item.rel);
                    document.head.append(link);
                }
                instance.linkContainers.push(link);
                return axios.get(src)
            });
            await Promise.all(linkPromiseList).then(()=>{
          
            }).catch(() => void 0)
        }
        const avatarSrc = resumeData[Module.AVATAR]?.data?.src
        if (avatarSrc) {
            try {
                await axios.get(avatarSrc)
            } catch (error) {
                
            }
        }
        if(!instance.version.currentVersion){
            instance.versionLog();
        }
        instance.isInit = true;
        update()
    };
    const onInitHandler = async () => {
        const {pagination} = store.getState();
        await new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, 200)
        })
        if (pagination.openAutoPagination) {
            await instance.pagination();
        }
        instance.updateContentHeight();
        instance.visible = true;
        update()
        onInit?.()
    }
    const onScroll = () => {
        instance.zoomContainer.scrollTop = 0;
    };
    const cCallback = async () => {
        // return
        try {
            if (!instance.isInit) return
            const {pagination} = store.getState()
            if (pagination.openAutoPagination) {
                await instance.pagination();
            }
            instance.updateContentHeight();
        } catch (e) {
            console.error(e)
        }
    }
    useImperativeHandle(resumeRef, () => (instance));

    useEffect(() => {
        if (instance.isInit && resume && width) {
            onInitHandler()
        }
    }, [instance.isInit, width, resume]);
    useEffect(() => {
        if(instance.isInit){
            instance.changeTheme(resume.themeIndex)
        }
    }, [resume.themeIndex]);
    
    useEffect(() => {
        const fontSize = resume.fontSize
        document.querySelector('.wbdCv-baseStyle')?.setAttribute('data_font_size', fontSize)
        document.querySelector('.resume-content-all')?.setAttribute('data_font_size', fontSize)


        const pageMargin = resume.pageMargin
        if (pageMargin !== undefined) {
            // console.log('pageMargin', pageMargin)
            // document.querySelector('.wbdCv-baseStyle')?.setAttribute('data-modal_pagemargin', -1)
            // document.querySelector('.resume-content-all')?.setAttribute('data-modal_pagemargin', pageMargin)
        }

        const moduleMargin = resume.moduleMargin
        document.querySelector('.wbdCv-baseStyle')?.setAttribute('data-modal_margin', moduleMargin)
        document.querySelector('.resume-content-all')?.setAttribute('data-modal_margin', moduleMargin)

        if(resume.fontFamily){
            document.querySelector('.wbdCv-baseStyle')?.setAttribute('data_font_name', resume.fontFamily)
            document.querySelector('.resume-content-all')?.setAttribute('data_font_name', resume.fontFamily)
        }
    }, [resume.fontSize, resume.fontFamily, resume.pageMargin, resume.moduleMargin])

    useEffect(() => {
        initData();

    }, []);
    useEffect(() => {
        cCallback()
        console.log('onePageLevel',onePageLevel)
        setTechPageState(onePageLevel?'cancel' :'normal')
    }, [resumeData, openAutoPagination, openAutoOnePage, onePageLevel]);
    useDataChange(onChange, instance);
    useVersion();
    usAiDecision();
    useEffect(() => {
        return () => {
            try {
                instance.linkContainers.forEach((link) => {
                    document.head.removeChild(link);
                })
            } catch (e) {

            }
        }
    }, [])

    const [mouseEnter, setMouseEnter] = useState(false)
    // normal|loading|cancel
    const [techPageState,setTechPageState] = useState('normal')
    const icon = ( type)=>{
        const style = { transform: 'translate( 0px ,-2px)',margin: '0  8px',color:'#fff' }
        switch(type){
            case 'normal':
                return <NormalIcon style={style} />
            case 'loading':
                return <LoadingIcon  style={style} />
            case 'cancel':
                return <CancelIcon style={style} />
        }
    }
    const text = ( type)=>{
        switch(type){
            case 'normal':
                return '智能一页'
            case 'loading':
                return '调整中...'
            case 'cancel':
                return '取消一页'
        }
    }

    const clickPageButton = () =>{
        if(techPageState === 'normal'){
            setTechPageState('loading')

            clickPageButtonQuery()
        }else if(techPageState === 'cancel'){
            setTechPageState('loading')

            clickPageButtonQuery('normal')
        }
    }

    const [scrollY, setScrollY] = useState(window.scrollY);

    useEffect(() => {
      const handleScroll = () => {
        setScrollY(window.scrollY);
        console.log(window.scrollY)
      };
  
      // 添加滚动事件监听器
      window.addEventListener('scroll', handleScroll);
  
      // 清理函数
      return () => {
        // 移除滚动事件监听器
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);  // 

    const clickPageButtonQuery = () => {
        const hide = message.loading("", 0)
        const status = techPageState
        let content = status === 'normal' ? '已调整为一页纸' : '已取消一页纸'
        instance.pagination().then((res)=>{
            console.log(res)
        })
        instance.mergeOnePage().then((res)=>{
            
        }).catch(() => {
            setTechPageState('normal')
            message.info("内容过长,无法合并一页")
            content = ''
        }).finally(() => {
            if(content){
                message.success(content)
            }
            hide()
        })
    }
    if (!width || !resume) return
    return <>
        <ContainerStyled 
        onMouseEnter={()=>setMouseEnter(true)}
        onMouseLeave={()=>setMouseEnter(false)}
        id={'resume-' + resume.resumeId} ref={rootRefHandler}
                         className={'resume-' + resume.originTemplateId}
                         style={{
                             width,
                             pointerEvents: openEdit ? undefined : "none",
                             position: "relative",
                             height: instance.currenContentHeight,
                             overflow: 'hidden',
                             visibility: instance.visible ? undefined : "hidden"
                         }}>
            {
                !isDown && <Pagination pageCount={instance.pageCount}
                                       openEdit={openEdit}
                                       paginationCoverHeight={instance.paginationCoverHeight}
                                       currentPageHeight={instance.currentPageHeight}/>
            }
            {mouseEnter && <div className="page-button" onClick={clickPageButton} >
                {icon(techPageState)}{text(techPageState)} <div style={{display: techPageState === 'cancel'?'none':'block',marginLeft:'3px' }}> </div></div>}
            <div style={{
                height: instance.currenContentHeight,
                background: "white",
                position: "absolute",
                top: 0,
                width: "100%",
                zIndex: 1,
                paddingBottom: 20
            }}/>
            <div ref={zoomRefHandler} onScroll={onScroll} style={{
                position: "relative",
                width: baseWidth,
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                zIndex: 2,
            }}>
                <div id="test1">
                    <div style={{position: "relative", zIndex: "inherit"}}>
                        <div ref={contentRefHandler}
                             className="ll-resume-content"
                             style={{position: "relative", zIndex: "inherit", height: instance.contentHeight}}>
                            {configRender(template.layoutConfig, resumeData)}
                        </div>
                    </div>
                </div>
            </div>
        </ContainerStyled>
        <div ref={(container) => instance.mergeOnePageContainer = container}
             style={{visibility: "hidden", pointerEvents: "none", position: "fixed", top: 0, right: -1000}}/>
    </>
})));

export default Component
